export default {
  defaultProvider: 'rest-local',
  providers: {
    rest: {
      type: 'rest',
      baseUrl: '//jsonplaceholder.typicode.com/',
      config: {
        sections: 'sections',
        search: 'posts',
        links: 'todos'
      }
    },
    'rest-local': {
      type: 'rest',
      baseUrl: 'https://theatheor-sls.netseven.it/',
      // baseUrl: 'http://localhost:3000/',
      config: {
        home: 'get_home',
        menu: 'get_menu',
        static: 'get_static/',
        search: 'search/results',
        advancedSearch: 'advanced_search',
        facets: 'search/facets',
        resource: 'get_resource',
        footer: 'get_footer',
        translation: 'get_translation/',
        xmlSearch: 'search_text_hl/',
        getPdf: 'getPDF'
      }
    }
  }
};
